export const categoryWidth = 350;
export const bidWidth = 80;
export const categoryNameWidth = 220;
export const categoryCoverageWidth = 75;
export const categoryNameHeaderWidth = 160;
export const categoryCoverageHeaderWidth = 160;
